<template>
  <div class="navbar-custom">
    <ul class="list-unstyled topnav-menu float-right mb-0">

      <b-nav-item-dropdown
        right
        class="notification-list"
        menu-class="profile-dropdown"
      >
        <template slot="button-content">
          <div class="nav-user mr-0 waves-effect waves-light">

            <span class="pro-user-name ml-1">
              {{user ? user.name + ' ' + user.surname  : ''}} <i class="mdi mdi-chevron-down"></i>
            </span>
          </div>
        </template>

        <b-dropdown-item href="/app/profile">
          <i class="fe-user mr-1"></i>
          <span>Profile</span>
        </b-dropdown-item>

        <b-dropdown-divider></b-dropdown-divider>

        <b-dropdown-item href="/logout">
          <i class="fe-log-out mr-1"></i>
          <span>Logout</span>
        </b-dropdown-item>
      </b-nav-item-dropdown>
    </ul>

    <!-- LOGO -->
    <div class="logo-box">
      <router-link class="logo text-center" tag="a" to="/app/dashboard">
        <span class="logo-lg">
          <img
            src="@assets/images/logo-dark.png"
            alt="Roster"
            height="40"
          />
        </span>
        <span class="logo-sm">
          <img
            src="@assets/images/logo-dark.png"
            alt="Roster"
            height="24"
          />
        </span>
      </router-link>
    </div>

    <ul class="list-unstyled topnav-menu topnav-menu-left m-0">
      <li>
        <button
          class="button-menu-mobile waves-effect waves-light"
          @click="toggleMenu"
        >
          <i class="fe-menu"></i>
        </button>
      </li>

    </ul>
  </div>
</template>

<script>
import { authComputed } from '@state/helpers'

export default {
  props: {
    user: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    agency: {
      type: Object,
      required: true,
      default: () => ({}),
    }
  },
  data() {
    return {}
  },
  computed: {
    ...authComputed,
  },
  methods: {
    toggleMenu () {
      this.$parent.toggleMenu()
    },
    checkPermission(roles) {
      return roles.some((r) => this.user.userRoles.includes(r))
    }
  }
}
</script>

<style lang="scss">
.noti-scroll {
  height: 220px;
}
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
.button-menu-mobile {
  outline: none !important;
}
</style>
